// ...existing code...
<template>
  <div class="container forgot-password py-4">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6">
        <div class="card shadow-sm">
          <div class="card-body">
            <h3 class="card-title mb-3">Recuperar contraseña</h3>

            <form @submit.prevent="submit" novalidate>
              <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input
                  id="email"
                  v-model="email"
                  type="email"
                  required
                  class="form-control"
                  placeholder="tu@correo.com"
                />
              </div>

              <div class="d-flex justify-content-end">
                <button class="btn btn-primary" :disabled="loading" type="submit">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ loading ? 'Enviando...' : 'Enviar instrucciones' }}
                </button>
              </div>

              <div class="mt-3">
                <div v-if="message" :class="['alert', error ? 'alert-danger' : 'alert-success']" role="alert">
                  {{ message }}
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios' // ajusta si importas axios globalmente

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      loading: false,
      message: null,
      error: false
    }
  },
  methods: {
    async submit() {
      this.loading = true
      this.message = null
      this.error = false
      try {
        const res = await axios.post('/api/password/forgot', { email: this.email })
        this.message = res.data.message || 'Se envió el correo. Revisa tu bandeja.'
      } catch (err) {
        this.error = true
        this.message = (err.response && (err.response.data.message || (err.response.data.errors && Object.values(err.response.data.errors).flat().join(', ')))) || 'Error de envío'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.forgot-password { min-height: 220px; }
.card { border-radius: 0.75rem; }
.card-title { font-weight: 600; }
@media (max-width: 576px) {
  .forgot-password { padding-left: 0.5rem; padding-right: 0.5rem; }
}
</style>
// ...existing code...